// extracted by mini-css-extract-plugin
module.exports = {"my_bonus_modal":"BonusModal_my_bonus_modal__uCm6g"};